export const EMAILS_NOTIFICATION_NEED_RECONNECT_ACCOUNT = 'needReconnect'
